export enum TipoDadoEnum {
	Obrigacao = 0,
	Etapa = 1,
}
